import React from 'react';
import { Table, Button, Space, Tag, Image } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined, LinkOutlined } from '@ant-design/icons';

const BlogHighlightTable = ({ blogHighlights, onEdit, onDelete, onToggleStatus }) => {
  if (!blogHighlights || blogHighlights.length === 0) {
    return null; // Handled by parent component
  }

  const linkTypeLabel = {
    pdf: 'PDF',
    external: 'External',
    internal: 'Internal'
  };

  const columns = [
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Highlight</span>,
      key: 'highlight',
      render: (_, item) => {
        const title = item?.title || 'Untitled';

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Image
              src={item.image}
              alt={title}
              width={60}
              height={40}
              style={{
                objectFit: 'cover',
                borderRadius: '4px'
              }}
              fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='40'%3E%3Crect width='100%25' height='100%25' fill='%23e6d5f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23470172' font-size='12'%3EImg%3C/text%3E%3C/svg%3E"
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 600, color: '#470172' }}>
                {title}
              </div>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#8b8b8b' }}>
                {item.badgeDay} {item.badgeMonth} {item.badgeYear}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Link Type</span>,
      dataIndex: 'linkType',
      key: 'linkType',
      responsive: ['md'],
      render: (linkType) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <LinkOutlined style={{ color: '#470172' }} />
          <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#470172' }}>
            {linkTypeLabel[linkType] || linkType}
          </span>
        </div>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Order</span>,
      dataIndex: 'order',
      key: 'order',
      responsive: ['lg'],
      render: (order) => (
        <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#470172' }}>
          {order}
        </span>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Status</span>,
      key: 'status',
      responsive: ['md'],
      render: (_, item) => (
        <Tag
          color={item.isActive ? 'success' : 'default'}
          style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400 }}
        >
          {item.isActive ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Actions</span>,
      key: 'actions',
      align: 'right',
      render: (_, item) => (
        <Space size="small">
          <Button
            type="text"
            icon={item.isActive ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={() => onToggleStatus(item._id)}
            style={{
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(item)}
            style={{
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(item._id)}
            style={{
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={blogHighlights}
      rowKey="_id"
      scroll={{ x: 'max-content' }}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        style: { fontFamily: 'Rubik, sans-serif' }
      }}
      style={{ fontFamily: 'Rubik, sans-serif' }}
    />
  );
};

export default BlogHighlightTable;
